import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { createCustomPropType, isNumeric } from '../../../js/app/react/validators';
import { isVisible } from '../AdvWorkflow/AdvWorkflowHelpers';

class AdvWorkflowStepView extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      canBeMadeVisible: false,
    };
  }

  UNSAFE_componentWillReceiveProps({ branch, iterator }) {
    const visible = isVisible(branch, iterator);
    if (!visible && this.state.visible) {
      this.setState({
        visible: false,
      });
    }
  }

  componentDidUpdate(
    { iterator: previousIterator },
    { canBeMadeVisible: previousCanBeMadeVisible },
  ) {
    const {
      workflowId,
      clientId,
      skip,
      branch,
      iterator,
      canSkip,
      isPopulated,
      isFirstStep,
      isGoingForward,
      isGoingBackward,
    } = this.props;
    // We need to disable linter rules because we don't do layout thrashing here. The component
    // is invisible at this point
    const visible = isVisible(branch, iterator);
    if (!isVisible(iterator, previousIterator) && this.state.canBeMadeVisible) {
      // eslint-disable-next-line
      this.setState({
        canBeMadeVisible: false,
      });
    }
    if (visible) {
      if (isFirstStep) {
        if (isPopulated && !this.state.canBeMadeVisible) {
          // eslint-disable-next-line
          this.setState({
            canBeMadeVisible: true,
          });
        }
      } else if (!this.state.canBeMadeVisible) {
        // eslint-disable-next-line
        this.setState({
          canBeMadeVisible: true,
        });
      }
      if (!previousCanBeMadeVisible && this.state.canBeMadeVisible) {
        if (canSkip) {
          skip(isGoingForward, isGoingBackward, workflowId, clientId);
          if (!isGoingBackward && !isGoingForward) {
            // eslint-disable-next-line
            this.setState({
              visible: true,
            });
          }
        } else if (this.state.visible !== true) {
          // eslint-disable-next-line
          this.setState({
            visible: true,
          });
        }
      }
    }
  }

  render() {
    const { id, children, className } = this.props;
    const { visible } = this.state;
    if (visible) {
      return (
        <div className={`step ${className}`} id={id}>
          {children}
        </div>
      );
    }
    return null;
  }
}

AdvWorkflowStepView.defaultProps = {
  id: null,
  iterator: null,
  canSkip: false,
  className: '',
};

AdvWorkflowStepView.propTypes = {
  isGoingBackward: PropTypes.bool.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number.isRequired),
  canSkip: PropTypes.bool,
  workflowId: PropTypes.string.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  skip: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default AdvWorkflowStepView;
